import React from 'react';

import styled from 'styled-components';

import CardAverage from 'common/Widgets/Card/CardAverage';
import CardRating from 'common/Widgets/Card/CardRating';
import { LIVING_TYPES_LABELS } from 'constants/livingTypes';
import { useAppSelector } from 'store/hook';
import { convertRatePerAreaByUnitSystem, getAreaUnitLabel } from 'utils/helpers/units';

import { useOverviewStatsContext } from './OverviewStatsContext';
import { CommunityStatsAccommodationTypeEntryData } from './types';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 20px;
`;

const OverviewAverages = () => {
  const { overviewStats } = useOverviewStatsContext();
  const { selectedCommunity, communities, competitors } = useAppSelector((state) => state.global);
  const hasUnitSystem = (community?: any) => Boolean(community?.unit_system || community?.preferences?.unit_system);
  const fallbackCommunity = [...(communities || []), ...(competitors || [])].find((community) =>
    hasUnitSystem(community)
  );
  const unitSource = selectedCommunity || fallbackCommunity;
  const areaUnitLabel = getAreaUnitLabel(unitSource);
  const formatRatePerArea = (value?: number) =>
    typeof value === 'number' ? convertRatePerAreaByUnitSystem(value, unitSource) : value;

  return (
    <Container>
      <CardAverage
        footerLabel="Competitor avg."
        title="Market Rate"
        subtitle="All Care Types · Average"
        value={overviewStats?.base_rent?.community}
        market_value={overviewStats?.base_rent?.market}
      />
      {overviewStats?.living_types?.map((item: CommunityStatsAccommodationTypeEntryData) => (
        <CardAverage
          key={item.living_type_id}
          footerLabel="Competitor avg."
          title="Market Rate"
          subtitle={`${LIVING_TYPES_LABELS[item.living_type_id]} · Average`}
          value={item.community}
          market_value={item.market}
        />
      ))}
      <CardAverage
        footerLabel="Competitor avg."
        title={`Rate/${areaUnitLabel}`}
        subtitle="All Room Types · Average"
        value={formatRatePerArea(overviewStats?.price_per_square_foot?.community)}
        market_value={formatRatePerArea(overviewStats?.price_per_square_foot?.market)}
      />
      <CardRating
        title="Rating"
        subtitle="All Sources · All Categories"
        value={overviewStats?.ratings?.community || 0}
        total={overviewStats?.ratings?.community_count || 0}
        market_value={overviewStats?.ratings?.market || 0}
      />
    </Container>
  );
};

export default OverviewAverages;
